<div class="flex min-h-screen">
  <!-- Sidebar -->
  <nav
    [ngClass]="{ hidden: !isSidebarOpen }"
    class="min-h-full border-r-2 border-black bg-[#205618] md:flex md:flex-col"
  >
    <div
      class="mt-3 h-10 items-center px-6"
      [ngClass]="{
        'justify-end': isSidebarOpen,
        hidden: isSidebarOpen,
        'md:flex': true
      }"
    >
      <button class="text-xl focus:outline-none" (click)="toggleSidebar()">
        <fa-icon [icon]="'bars'"></fa-icon>
      </button>
    </div>
    <app-sidebar [isSidebarOpen]="isSidebarOpen"></app-sidebar>
  </nav>

  <!-- Main content -->
  <div class="flex flex-1 flex-col overflow-hidden">
    <!-- Header -->
    <header class="flex items-center justify-between shadow">
      <app-header class="w-full" [isLoggerPage]="true"></app-header>
    </header>
    <header
      class="flex items-center justify-between border-b-2 border-black bg-[#205618] px-2 py-1 shadow md:hidden"
    >
      <p class="pt-2 text-sm font-bold">{{ currentUrl | urlToLinkTitle }}</p>
      <button class="text-xl focus:outline-none" (click)="toggleSidebar()">
        <fa-icon [icon]="'bars'"></fa-icon>
      </button>
    </header>

    <!-- Content -->
    <main class="flex-1 overflow-y-auto p-2">
      <div class="mx-auto w-full">
        <!-- Replace with actual content -->
        <ng-content selector=".child"></ng-content>
      </div>
    </main>
  </div>
</div>
